export const JOZ_LLM_IDENTITY = {
  name: "Jozef Krupa",
  label: "Joz MAXX",
  website: "https://meetjoz.com",
  email: "joz@meetjoz.com",
  phone: "+65 3107 2412",
  whatsapp: "+41 76 497 38 94",
  location: "Singapore / Dubai / Europe / global markets",
};

export const JOZ_LLM_CV = {
  headline:
    "Agentic AI architect and applied AI product leader with 13+ years of experience overall, including 8+ years in ML/AI, across finance, insurance, media, public-sector innovation, spatial computing, and intelligent interfaces.",
  globalScale: [
    "North America",
    "Europe/EEA",
    "United Kingdom",
    "UAE/MENA",
    "Singapore",
    "Japan",
    "Greater China",
    "Australia",
    "Wider Asia Pacific",
  ],
  appliedAiSkills: {
    architecture: [
      "Agentic intelligence systems",
      "Autonomous reasoning and orchestration",
      "LLMs, RAG, embeddings, vector search, knowledge graphs, and context engineering",
      "Memory architectures, retrieval systems, ACL-aware access, verification, and feedback loops",
      "Event-driven production AI and asynchronous workflows",
      "Secure API ecosystems and cloud-native platforms",
      "Data platforms, observability, and AI governance",
    ],
    orchestration: [
      "Self-organising AI metamaterials",
      "Context-aware multimodal interactions",
      "Voice, touch, gesture, gaze, and haptics",
      "Telemetry and behavioral data powering agentic feedback loops",
      "Real-time signals mapped to human mental models",
      "Volumetric and spatial AI interfaces",
      "NLP/CV-driven personalization with intent modeling and semantic retrieval",
      "Anticipatory, predictive, assistive, and autonomous decision-making intelligence",
    ],
    uxLeadership: [
      "World-class UX and interaction design",
      "Human-centered design operating models",
      "Design systems and code-based prototyping",
      "Cross-functional translation from design to engineering to executive buy-in",
      "Accessibility, trust, and production-grade experience quality",
    ],
    signalSystems: [
      "Signal reasoning and continuous-signal interpretation",
      "Operational sensing, detection logic, and decision support",
      "Python-led prototyping and production service thinking",
      "SQL, APIs, orchestration, and model-informed UX",
      "Telemetry, feedback loops, and measurable operating outcomes",
      "System framing that connects signals, interfaces, and action",
    ],
  },
  experience: [
    {
      title: "Agentic AI Architecture and Innovation Leader",
      period: "2018-Present",
      regions: "Singapore, Dubai, Zurich and Europe/EU/EEA",
      highlights: [
        "Architected financial AI agents with live data and asset portfolios for MC USA.",
        "Pioneered spatial AI for world-class art exhibitions in Dubai through ArtKorero.",
        "First in Dubai to design and launch spatial AI with volumetric 3D UI for Versace/SOA.",
        "Rapid-prototyped AI initiatives for Dubai Future Foundation and adjacent UAE innovation work.",
        "Drove engineering and EU accessibility transformation at Erste Bank, serving 16M+ customers.",
        "Led HCD-AI, product, and data architectures across 20+ Dubai and Singapore fintechs.",
        "Pioneered Python USD(z) and computer vision AI workflows in Singapore with Apple/Pixar-adjacent work.",
      ],
    },
    {
      title: "Private Banking Experience Architecture Manager",
      period: "2016-2018",
      regions: "Maybank-Ageas Etiqa, Singapore and Asia Pacific",
      highlights: [
        "Delivered 20x growth in digital sales within 12 months via conversational and ML-led UX.",
        "Designed 3,000+ wealth pilots and ML models for HNW and mass-market clients.",
        "Established an HCD-AI practice and trained C-suite executives and regional teams.",
      ],
    },
    {
      title: "Engineering Innovation Fellow",
      period: "2015-2016",
      regions: "Manulife, Singapore and Asia Pacific",
      highlights: [
        "Established a Lean ML UX practice across 11 markets as a founding APAC hire.",
        "Launched first-in-market ML UX solutions in the USA, Canada, and Singapore.",
        "Advised APAC regional CEOs on digital growth strategies that scaled globally.",
      ],
    },
    {
      title: "Global Engineering Architect",
      period: "2014-2015",
      regions: "Mediacorp, Singapore and Asia Pacific",
      highlights: [
        "First in Asia to ship the CNA Apple Watch app, globally featured by Apple.",
        "Achieved 30x MAU audience growth through mobile-first transformation.",
        "Built a global experience language standardizing interaction design across 30+ products.",
      ],
    },
    {
      title: "Senior Engineer",
      period: "2014",
      regions: "Leo Burnett/Publicis, Singapore and Asia Pacific",
      highlights: [
        "Delivered SK-II's first luxury e-commerce experience in the USA and across 8 APAC markets.",
        "Developed mobile-first apps for P&G brands and Samsung.",
        "Reduced agency-wide handoff friction by 70% through code-based prototyping.",
      ],
    },
    {
      title: "Senior Interaction Engineer",
      period: "2013-2014",
      regions: "Ogilvy/WPP, Singapore and Asia Pacific",
      highlights: [
        "Built the prototype that won Banyan Tree's multi-million-dollar agency pitch.",
        "Re-engineered the Singapore Stock Exchange's responsive listings portals.",
        "Deployed cross-platform UGC apps for Danone across 8 APAC markets.",
      ],
    },
  ],
  education: [
    "MSc Strategy and Innovation, University of Lancashire, United Kingdom",
    "Innovation Strategist (University Appointment), University of Lancashire, United Kingdom",
    "MIT/IDEO Design Thinking and human-centered design certifications",
    "Apple Design Labs and Apple Engineering Labs participation focused on AI and spatial computing",
    "HPI d.school prototyping labs and human-centered design training",
  ],
};

export const TARGET_DATA_SCIENTIST_ROLE = {
  company: null,
  title: "Agentic AI Architecture and Applied Intelligence Lead",
  location: "Signal-rich / regulated environment",
  mission:
    "Turn complex signals, workflows, and interfaces into agentic AI systems that produce actionable decisions and operational intelligence.",
  responsibilities: [
    "Architect and ship agentic AI systems with retrieval, orchestration, and production observability.",
    "Write packaged, versioned, testable Python and service-layer code with clear interfaces.",
    "Work across continuous signals, telemetry, multimodal inputs, and operational workflows.",
    "Collaborate with engineers, operators, product leaders, and executive stakeholders.",
    "Design decision surfaces that make intelligence legible, trusted, and usable.",
  ],
  requirements: [
    "Agentic AI architecture, orchestration, and context engineering",
    "LLMs, RAG, embeddings, vector search, and retrieval systems",
    "Signal reasoning across noisy, high-dimensional operational contexts",
    "Python, SQL, APIs, and production systems fluency",
    "Observability, governance, and workflow-aware deployment judgment",
    "Strong communication of technical and strategic decisions",
  ],
};

export const JOZ_LLM_SUGGESTIONS = [
  "Why is Joz a fit for this role?",
  "Map Joz to the job description",
  "Show evidence for agentic AI and orchestration",
  "How would Joz design an agentic AI system for a signal-rich environment?",
  "What would Joz do in the first 90 days?",
];

const JOZ_REFERENCE_REWRITES = [
  [/\bI am\b/gi, "Joz is"],
  [/\bI'm\b/gi, "Joz is"],
  [/\bI’ve\b/gi, "Joz has"],
  [/\bI've\b/gi, "Joz has"],
  [/\bI’d\b/gi, "Joz would"],
  [/\bI'd\b/gi, "Joz would"],
  [/\bI’ll\b/gi, "Joz will"],
  [/\bI'll\b/gi, "Joz will"],
  [/\bmy\b/gi, "Joz's"],
  [/\bmine\b/gi, "Joz's"],
  [/\bme\b/gi, "Joz"],
  [/\bI\b/gi, "Joz"],
  [/\bhe is\b/gi, "Joz is"],
  [/\bhe's\b/gi, "Joz is"],
  [/\bhe\b/gi, "Joz"],
  [/\bhim\b/gi, "Joz"],
  [/\bhis\b/gi, "Joz's"],
];

export function buildJozLlmSystemPrompt() {
  return [
    "You are Joz MAXX, an elite role-aware hiring agent representing Jozef Krupa.",
    "Your job is to translate Joz's real background into precise, evidence-based answers focused on agentic AI architecture, applied intelligence systems, multimodal orchestration, and signal-rich operational environments.",
    "Always refer to the subject as Joz.",
    "Never use first-person language such as I, me, my, or mine.",
    "Never use third-person pronouns such as he, him, his, or he's.",
    "Use Joz or Joz's instead, while staying factual and specific.",
    "Keep responses short and punchy by default.",
    "Prefer one tight paragraph or at most 2 concise bullets unless more depth is explicitly asked for.",
    "Default to 2 to 3 short sentences total.",
    "Stay at or under roughly 55 words unless the user explicitly asks for detail.",
    "Lead with the answer, not setup or framing.",
    "The embedded profile and CV context are authoritative for Joz identity, education, geography, and experience.",
    "If the user asks about education, qualifications, regions, or career background, answer directly from the provided profile instead of saying the information is unavailable.",
    "Do not invent employers, degrees, models shipped, or production claims beyond the provided profile.",
    "When there is a gap, position it honestly as adjacent strength plus a concrete ramp plan.",
    "Bias toward agentic AI, applied AI architecture, orchestration, multimodal intelligence, production engineering, observability, and measurable impact.",
    "For broad credibility or scale questions, prefer Maybank and Manulife as the lead proof points, then Mediacorp, and position Erste Bank as supporting proof unless the question is explicitly about Europe, accessibility, or Erste Bank.",
    "Avoid generic motivational language and avoid sounding like a chatbot.",
  ].join(" ");
}

function closeReplyEnding(text = "") {
  let value = String(text || "").trim();
  if (!value) return "";

  value = value.replace(/[,:;\-–—]\s*$/, "").trim();
  value = value.replace(
    /\b(and|or|but|with|via|through|across|into|for|to|of|in|on|at|by|under|over|before|after|from|than|that|which|while|because|so|then)\s*$/i,
    ""
  ).trim();

  if (!value) return "";
  if (/[.!?]$/.test(value)) return value;
  return `${value}.`;
}

export function enforceJozLlmReplyLimit(text = "", maxWords = 55) {
  let normalized = String(text || "").replace(/\s+/g, " ").trim();
  if (!normalized) return "";

  for (const [pattern, replacement] of JOZ_REFERENCE_REWRITES) {
    normalized = normalized.replace(pattern, replacement);
  }

  normalized = normalized.replace(/\s+/g, " ").trim();

  const words = normalized.split(" ");
  if (words.length <= maxWords) return closeReplyEnding(normalized);

  const truncated = words.slice(0, maxWords).join(" ");
  const sentenceClosed = closeReplyEnding(truncated);
  return sentenceClosed || closeReplyEnding(normalized);
}

export function buildJozLlmContext() {
  return {
    identity: JOZ_LLM_IDENTITY,
    cv: JOZ_LLM_CV,
    targetRole: TARGET_DATA_SCIENTIST_ROLE,
  };
}

export function buildJozLlmFallbackReply(message = "") {
  const clean = String(message || "").trim().toLowerCase();

  if (
    clean.includes("course") ||
    clean.includes("courses") ||
    clean.includes("certification") ||
    clean.includes("certifications") ||
    clean.includes("education") ||
    clean.includes("study") ||
    clean.includes("studies") ||
    clean.includes("studied") ||
    clean.includes("school") ||
    clean.includes("schools") ||
    clean.includes("academic") ||
    clean.includes("academics") ||
    clean.includes("qualification") ||
    clean.includes("qualifications") ||
    clean.includes("degree") ||
    clean.includes("degrees") ||
    clean.includes("master") ||
    clean.includes("university") ||
    clean.includes("mit") ||
    clean.includes("ideo") ||
    clean.includes("hpi") ||
    clean.includes("wwdc") ||
    clean.includes("apple design labs")
  ) {
    return "Joz holds an MSc in Strategy and Innovation from the University of Lancashire and held an Innovation Strategist university appointment there. Joz also completed MIT/IDEO Design Thinking, HPI d.school prototyping labs, and Apple Design Labs and WWDC programs focused on AI and spatial computing.";
  }

  if (
    clean.includes("fit") ||
    clean.includes("match") ||
    clean.includes("why")
  ) {
    return "Joz is strongest where AI has to work under real constraints. Joz's edge is agentic systems, signal interpretation, orchestration quality, Python-led delivery, and production-minded architecture.";
  }

  if (
    clean.includes("time-series") ||
    clean.includes("timeseries") ||
    clean.includes("signal") ||
    clean.includes("anomaly")
  ) {
    return "Joz is strongest in structured intelligence over continuous signals. That maps well to signal reasoning, process-state interpretation, detection logic, and monitored decision loops.";
  }

  if (
    clean.includes("90 days") ||
    clean.includes("first 90") ||
    clean.includes("ramp")
  ) {
    return "First 30 days: map data, stakeholders, bottlenecks, and the stack. By day 60: define one anomaly-monitoring use case with metrics. By day 90: ship one monitored pilot with a retraining path.";
  }

  if (
    clean.includes("digital twin") ||
    clean.includes("industrial") ||
    clean.includes("process")
  ) {
    return "A digital twin should be a decision layer, not just a visual one. It should combine process state, anomaly signals, forecasts, and model confidence to drive faster diagnosis and clearer action.";
  }

    return "Joz MAXX can explain Joz's fit, show agentic AI evidence, and outline how Joz would approach signal-rich systems, orchestration, and operational intelligence.";
}
